export enum PlanType {
    Prepaid = 1,
    Postpaid
}